var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import '../../lib/knockout_datePicker';
import "../../components/paging";
import * as Editor from 'wangeditor';
import { Configs } from "../../app-lib/constants";
import './projectInfo.css';
// let ed=Editor
// let flagDiv:any=this.container.querySelector('.projectInfo_body');
var projectInfoModel = /** @class */ (function (_super) {
    __extends(projectInfoModel, _super);
    function projectInfoModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.isCheck = ko.observable(false); //是否是查看
        _this.dataId = ko.observable('0000'); //项目id  0000时新增 
        _this.local = ko.observableArray(); //省份列表
        _this.localid = ko.observable(); //省份obj
        _this.localnext = ko.observable(); //城市列表
        _this.localsomeid = ko.observable(); //城市obj
        // 提交数据
        _this.closingDate = ko.observable(); //截止到填表时间
        _this.stage = ko.observable(); //该物业开发工作进行至 阶段
        _this.informationSources = ko.observable(); //信息来源
        _this.signingBodyList = ko.observableArray([{ text: '请选择', val: 0 }, { text: '开元国际', val: 1 }, { text: '万象美', val: 2 }]); //签约主体数组
        _this.signingBody = ko.observable(); //签约主体
        _this.otherSigningBody = ko.observable(false); //签约主体其他单选
        _this.otherSigningBodyVal = ko.observable(); //签约主体其他单选input值
        _this.developer = ko.observable(); //发展商
        _this.ownerSession = ko.observable(); //业主委员会第几届
        _this.ownerNumber = ko.observable(); //共几人
        _this.contacts = ko.observable(); //联系人：
        _this.post = ko.observable(); //职务：
        _this.contactNumber = ko.observable(); //联系电话：
        _this.supervisor = ko.observable(); //主管人：
        _this.supervisorPosition = ko.observable(); //主管职务：
        _this.supervisorNumber = ko.observable(); //主管联系电话：
        _this.propertyName = ko.observable(); //物业名称：
        _this.location = ko.observable(); //坐落位置：详细
        _this.sizhi = ko.observable(); //四至
        // 四至
        _this.east = ko.observable(); //
        _this.west = ko.observable(); //
        _this.south = ko.observable(); //
        _this.north = ko.observable(); //
        _this.fourToList = ko.observableArray([{ name: '东' }, { name: '南' }, { name: '西' }, { name: '北' }, { name: '东南' }, { name: '东北' }, { name: '西南' }, { name: '西北' }]); //四至列表
        _this.regionalType = ko.observableArray([]); //物业类型
        _this.regionalTypeList = ko.observableArray([{ name: '多层' }, { name: '小高层' }, { name: '高层' }, { name: '超高层' }, { name: '商住楼' }, { name: '混合' }, { name: '住宅区' }, { name: '组团' }, { name: '写字楼' }, { name: '工业区' }]); //物业类型
        _this.areaName = ko.observable(); //周边自然环境描述：
        _this.commencementDate = ko.observable(); //开工日期：
        _this.commencementDateTBD = ko.observable(false); //开工日期：待定
        _this.completionDate = ko.observable(); //竣工日期：
        _this.completionDateTBD = ko.observable(false); //竣工日期：待定
        _this.openDate = ko.observable(); //开盘日期：
        _this.openDateTBD = ko.observable(false); //开盘日期：待定
        _this.accessionDate = ko.observable(); //入伙日期：
        _this.accessionDateTBD = ko.observable(false); //入伙日期：待定
        _this.areaCovered = ko.observable(); //占地面积：
        _this.totalBuildings = ko.observable(); //建筑总栋数：
        _this.totalBuildingsTBD = ko.observable(); //建筑总栋数：待定
        _this.lobbyNumber = ko.observable(); //大堂数：
        _this.totalHouseholds = ko.observable(); //总户数：
        _this.totalArea = ko.observable(); //总建筑面积：
        _this.totalAreaTBD = ko.observable(false); //总建筑面积：待定
        _this.byStages = ko.observable(); //开发期数：
        _this.byStagesTBD = ko.observable(false); //开发期数：待定
        _this.numberPeriods = ko.observable(); //第 期 
        _this.numberPeriodsBuilding = ko.observable(); //建筑面积：
        _this.numberPeriodsResidential = ko.observable(); //住宅面积
        _this.commercialArea = ko.observable(); //商业面积
        _this.commercialAreaTBD = ko.observable(); //商业面积待定
        _this.amongBusinesses = ko.observable(); //商业其中
        _this.amongBusinessesList = ko.observableArray([{ name: '请选择' }, { name: '临街' }, { name: '裙楼' }]); //商业类型
        _this.amongBusinessesArea = ko.observable(); //商业其中面积
        _this.officAerea = ko.observable(); //写字楼面积：
        _this.officAereaTBD = ko.observable(false); //写字楼面积：待定
        _this.basementArea = ko.observable(); //地下室面积：
        _this.basementAreaTBD = ko.observable(false); //地下室面积：待定
        _this.basementFloors = ko.observable(); //地下室层数
        _this.basementFloorsTBD = ko.observable(); //地下室层数待定
        _this.clubArea = ko.observable(); //会所面积：
        _this.clubAreaTBD = ko.observable(false); //会所面积：无
        _this.publicConstructionArea = ko.observable(); //公建面积：大小
        _this.publicConstructionAreaList = ko.observableArray([{ name: '请选择' }, { name: '幼儿园' }, { name: '小学' }, { name: '其他' }]); //公建类型
        _this.publicConstructionAreaTBD = ko.observable(false); //公建面积：无
        _this.publicConstructionAreaType = ko.observable(); //公建面积：类型
        _this.afforestationRate = ko.observable(); //绿化率：
        _this.afforestedArea = ko.observable(); //绿化面积：
        _this.liftBrand = ko.observable(); //电梯品牌：
        _this.liftBrandTBD = ko.observable(false); //电梯品牌：待定
        _this.verticalLadder = ko.observable(); //电梯数量：垂直梯
        _this.escalator = ko.observable(); //电梯数量：扶梯
        _this.escalatorTBD = ko.observable(false); //电梯数量：扶梯 无
        _this.totallift = ko.observable(); //电梯数量：合计
        _this.parkingGroundCount = ko.observable(); //车场指标：地面车位数量
        _this.parkingGroundArea = ko.observable(); //地面车位 面积 
        _this.parkingUndergroundCount = ko.observable(); //地下车位数量
        _this.parkingUndergroundArea = ko.observable(); //地下车位面积
        _this.garageEntrance = ko.observable(); //出入口：车场入口
        _this.garageExit = ko.observable(); //出入口：车场出口
        _this.communityEntrance = ko.observable(); //出入口：小区入口
        _this.communityExit = ko.observable(); //出入口：小区出口
        _this.architecturalUnit = ko.observable(); //建筑规划设计单位：
        _this.landscapeUnit = ko.observable(); //园林景观设计单位：
        _this.salesUnit = ko.observable(); //销售策划单位：
        _this.constructionUnit = ko.observable(); //工程施工单位：
        _this.projectKey = ko.observable(); //项目规划设计要点：
        _this.designExplanation = ko.observable(); //设计说明：
        _this.planningMap = ko.observable(); //项目规划设计要点及设计说明书
        _this.effective = ko.observable(); //有效洽谈记录
        _this.editorone = new Editor('.projectInfo_editor_one');
        _this.editortwo = new Editor('.projectInfo_editor_two');
        _this.flagDiv = ko.observable(_this.container.querySelector('.projectInfo_body')); //日期选择器插入的目标div
        _this.projectType = ko.observable(); //项目类别
        _this.projectTypeList = ko.observableArray([{ name: '请选择' }, { name: '开发商项目' }, { name: '业委会项目' }]); //项目类别数组
        _this.houseTemeList = ko.observableArray([{
                amongThem: ko.observable(), amongThemArea: ko.observable(),
                amongThemList: ko.observableArray([{ name: '请选择' }, { name: '多层' }, { name: '高层' }, { name: '准高层' }, { name: '小高层' }, { name: '超高层' }])
            }]); //住宅其中数组
        return _this;
    }
    // 页面滑动
    projectInfoModel.prototype.bodyOnScrolls = function () {
        // console.log('flatpickr',flatpickr);
        // console.log(document.querySelectorAll('.flatpickr-calendar'));
        var nodeArr = document.querySelectorAll('.flatpickr-calendar');
        for (var i = 0; i < nodeArr.length; i++) {
            if (nodeArr[i].classList.length > 2) {
                nodeArr[i].classList.remove('open');
                if (nodeArr[i].classList[2] == 'arrowTop') {
                    nodeArr[i].classList.remove('arrowTop');
                }
                else {
                    nodeArr[i].classList.remove('arrowBottom');
                }
            }
        }
    };
    // 添加一条住宅其中
    projectInfoModel.prototype.addHouseTemeList = function () {
        if (this.houseTemeList().length > 4) {
            return window.popBox.show('最多添加五条');
        }
        else {
            this.houseTemeList.push({
                amongThem: ko.observable(), amongThemArea: ko.observable(),
                amongThemList: ko.observableArray([{ name: '请选择' }, { name: '多层' }, { name: '高层' }, { name: '准高层' }, { name: '小高层' }, { name: '超高层' }])
            });
        }
    };
    // 删除一条住宅其中
    projectInfoModel.prototype.deelteHouseTemeList = function (index) {
        this.houseTemeList.splice(index, 1);
    };
    // 加載富文本編輯器
    projectInfoModel.prototype.getEditor = function () {
        // editorone.customConfig.uploadImgServer = Configs.serviceUrl + '/api/supplement/upload';// 配置服务器端地址 upload:上传图片地址
        // editortwo.customConfig.uploadImgServer = Configs.serviceUrl + '/api/supplement/upload';// 配置服务器端地址 upload:上传图片地址
        // editorone.customConfig.uploadFileName = 'file'  //上传参数 自定义
        // editorone.customConfig.uploadImgParams = {
        //     uid: authorization.getUserId(), // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
        //     pid: this.dataId()// 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
        // }
        //可使用监听函数在上传图片的不同阶段做相应处理
        // editorone.customConfig.uploadImgHooks = {
        //     before: function (xhr: any, editor: any, files: any) {
        //         // 图片上传之前触发
        //         // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        //         // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        //         // return {
        //         //     prevent: true,
        //         //     msg: '放弃上传'
        //         // }
        //     },
        //     success: function (xhr: any, editor: any, result: any) {
        //         // 图片上传并返回结果，图片插入成功之后触发
        //         // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        //         console.log(xhr,editor,result);
        //     },
        //     fail: function (xhr: any, editor: any, result: any) {
        //         // 图片上传并返回结果，但图片插入错误时触发
        //         // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        //         console.log(xhr,editor,result);
        //     },
        //     error: function (xhr: any, editor: any) {
        //         // 图片上传出错时触发
        //         // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        //         console.log(xhr,editor);
        //     },
        //     timeout: function (xhr: any, editor: any) {
        //         // 图片上传超时时触发
        //         // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        //     },
        //     // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        //     // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        //     customInsert: function (insertImg: any, result: any, editor: any) {
        //         // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        //         // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        //         // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        //         var url = result.url
        //         insertImg(url)
        //         // result 必须是一个 JSON 格式字符串！！！否则报错
        //     }
        // }
        var that = this;
        this.editorone.customConfig.customUploadImg = function (files, insert) {
            // files 是 input 中选中的文件列表
            // insert 是获取图片 url 后，插入到编辑器的方法
            console.log(that, files);
            var fd = new FormData();
            for (var i = 0; i < files.length; i++) {
                fd.append('file', files[i]);
            }
            fd.append('uid', authorization.getUserId());
            fd.append('pid', that.dataId());
            ajax.post(Configs.serviceUrl + '/api/supplement/upload', fd).then(function (d) {
                if (d.status == '0') {
                    for (var n = 0; n < d.data.length; n++) {
                        insert(d.data[n].fileUrl); // 上传代码返回结果之后，将图片插入到编辑器中
                    }
                }
                else {
                    return window.popBox.show(d.message);
                }
            });
        };
        this.editortwo.customConfig.customUploadImg = function (files, insert) {
            // files 是 input 中选中的文件列表
            // insert 是获取图片 url 后，插入到编辑器的方法
            console.log(that, files);
            var fd = new FormData();
            for (var i = 0; i < files.length; i++) {
                fd.append('file', files[i]);
            }
            fd.append('uid', authorization.getUserId());
            fd.append('pid', that.dataId());
            ajax.post(Configs.serviceUrl + '/api/supplement/upload', fd).then(function (d) {
                if (d.status == '0') {
                    for (var n = 0; n < d.data.length; n++) {
                        insert(d.data[n].fileUrl); // 上传代码返回结果之后，将图片插入到编辑器中
                    }
                }
                else {
                    return window.popBox.show(d.message);
                }
            });
        };
        this.editortwo.customConfig.menus = [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            'table',
            // 'video',  // 插入视频
            'code',
            'undo',
            'redo' // 重复
        ];
        this.editorone.customConfig.menus = [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            'table',
            // 'video',  // 插入视频
            'code',
            'undo',
            'redo' // 重复
        ];
        this.editortwo.create();
        this.editorone.create();
    };
    // 返回
    projectInfoModel.prototype.goBack = function () {
        history.go(-1);
        this.clear();
    };
    // 新建，编辑提交
    projectInfoModel.prototype.subData = function () {
        var _this = this;
        if (!this.closingDate()) {
            return window.popBox.show('请选择截止到填表时间');
        }
        if (!this.stage()) {
            return window.popBox.show('请填写物业开发工作进行阶段');
        }
        if (this.stage().length > 100) {
            return window.popBox.show('物业开发工作进行阶段字段长度不能大于100');
        }
        if (!this.informationSources()) {
            return window.popBox.show('请填写信息来源');
        }
        if (this.informationSources().length > 100) {
            return window.popBox.show('信息来源字段长度不能大于100');
        }
        var signingBody = '';
        if (this.otherSigningBody()) {
            if (!this.otherSigningBodyVal()) {
                return window.popBox.show('请填写其他签约主体');
            }
            else {
                if (this.otherSigningBodyVal().length > 50) {
                    return window.popBox.show('其他签约主体段长度不能大于50');
                }
                else {
                    signingBody = this.otherSigningBodyVal();
                }
            }
        }
        else {
            if (this.signingBody() == '请选择') {
                return window.popBox.show('请选择签约主体');
            }
            else {
                signingBody = this.signingBody();
            }
        }
        var projectType = '';
        if (this.projectType() == '请选择') {
            return window.popBox.show('请选择项目类别');
        }
        else {
            projectType = this.projectType();
        }
        if (!this.developer()) {
            return window.popBox.show('请填写发展商');
        }
        if (this.developer().length > 50) {
            return window.popBox.show('发展商字段长度不能大于50');
        }
        if (!this.ownerSession()) {
            return window.popBox.show('请填写业主委员会届数');
        }
        if (this.ownerSession().length > 15) {
            return window.popBox.show('业主委员会届数字段不能大于15个字符');
        }
        if (!this.ownerNumber()) {
            return window.popBox.show('请填写业主委员会成员数');
        }
        if (this.ownerNumber().length > 15) {
            return window.popBox.show('业主委员会成员数字段不能大于15个字符');
        }
        if (!this.contacts()) {
            return window.popBox.show('请填写联系人');
        }
        if (!this.post()) {
            return window.popBox.show('请填写联系人职务');
        }
        if (!this.contactNumber()) {
            return window.popBox.show('请填写联系人联系电话');
        }
        else {
            if (!(/^1[3456789]\d{9}$/.test(this.contactNumber()))) {
                return window.popBox.show('联系人联系电话格式错误');
            }
        }
        // 主管人
        if (this.supervisorNumber()) {
            if (!(/^1[3456789]\d{9}$/.test(this.supervisorNumber()))) {
                return window.popBox.show('主管人联系电话格式错误');
            }
        }
        if (!this.propertyName()) {
            return window.popBox.show('请填写物业名称');
        }
        if (!this.location()) {
            return window.popBox.show('请填写具体坐落位置');
        }
        if (this.regionalType().length < 1) {
            return window.popBox.show('请选择物业类型');
        }
        // if (this.areaName()) {
        //     return window.popBox.show('请填写周边自然环境描述');
        // }
        // 四个连续日期
        var commencementDate;
        if (!this.commencementDateTBD()) {
            if (!this.commencementDate()) {
                return window.popBox.show('请选择开工日期');
            }
            else {
                commencementDate = this.commencementDate();
            }
        }
        else {
            commencementDate = '待定';
        }
        var completionDate;
        if (!this.completionDateTBD()) {
            if (!this.completionDate()) {
                return window.popBox.show('请选择竣工日期');
            }
            else {
                completionDate = this.completionDate();
            }
        }
        else {
            completionDate = '待定';
        }
        var openDate;
        if (!this.openDateTBD()) {
            if (!this.openDate()) {
                return window.popBox.show('请选择开盘日期');
            }
            else {
                openDate = this.openDate();
            }
        }
        else {
            openDate = '待定';
        }
        var accessionDate;
        if (!this.accessionDateTBD()) {
            if (!this.accessionDate()) {
                return window.popBox.show('请选择入伙日期');
            }
            else {
                accessionDate = this.accessionDate();
            }
        }
        else {
            accessionDate = '待定';
        }
        if (this.areaCovered()) {
            if (this.areaCovered().length > 15) {
                return window.popBox.show('占地面积字段长度不能大于15个字符');
            }
        }
        // 建筑总栋数
        var totalBuildings = '';
        if (!this.totalBuildingsTBD()) {
            if (!this.totalBuildings()) {
                return window.popBox.show('请填写建筑总栋数');
            }
            else {
                if (this.totalBuildings().length > 15) {
                    return window.popBox.show('建筑总栋数字段长度不能大于15个字符');
                }
                else {
                    totalBuildings = this.totalBuildings();
                }
            }
        }
        else {
            totalBuildings = '待定';
        }
        if (this.lobbyNumber()) {
            if (this.lobbyNumber().length > 15) {
                return window.popBox.show('大堂数字段长度不能大于15个字符');
            }
        }
        if (this.totalHouseholds()) {
            if (this.totalHouseholds().length > 15) {
                return window.popBox.show('总户数字段长度不能大于15个字符');
            }
        }
        // 总建筑面积
        var totalArea;
        if (!this.totalAreaTBD()) {
            if (this.totalArea()) {
                if (this.totalArea().length > 15) {
                    return window.popBox.show('总建筑面积字段长度不能大于15个字符');
                }
                else {
                    totalArea = this.totalArea();
                }
            }
            else {
                return window.popBox.show('请填写总建筑面积');
            }
        }
        else {
            totalArea = '待定';
        }
        // 开发期数：
        var byStages;
        if (!this.byStagesTBD()) {
            if (this.byStages()) {
                if (this.byStages().length > 15) {
                    return window.popBox.show('开发期数字段长度不能大于15个字符');
                }
                else {
                    byStages = this.byStages();
                }
            }
        }
        else {
            byStages = '待定';
        }
        if (this.numberPeriods()) {
            if (this.numberPeriods().length > 15) {
                return window.popBox.show('第几期字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写第几期');
        }
        if (this.numberPeriodsBuilding()) {
            if (this.numberPeriodsBuilding().length > 15) {
                return window.popBox.show('第几期建筑面积字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写第几期建筑面积');
        }
        if (this.numberPeriodsResidential()) {
            if (this.numberPeriodsResidential().length > 15) {
                return window.popBox.show('第几期住宅面积字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写第几期住宅面积');
        }
        // 住宅其他类型选择
        var amongThemArea = '';
        for (var t = 0; t < this.houseTemeList().length; t++) {
            if (this.houseTemeList()[t].amongThem() != '请选择' && this.houseTemeList()[t].amongThemArea()) {
                if (this.houseTemeList()[t].amongThemArea().length > 15) {
                    return window.popBox.show('某类型住宅面积字段长度不能大于15个字符');
                }
                else {
                    for (var m = t + 1; m < this.houseTemeList().length; m++) {
                        if (this.houseTemeList()[t].amongThem() == this.houseTemeList()[m].amongThem()) {
                            return window.popBox.show('第' + Number(t + 1) + '个住宅类型和第' + Number(m + 1) + '个住宅类型重复');
                        }
                    }
                    if (t < 1) {
                        amongThemArea = this.houseTemeList()[t].amongThem() + ',' + this.houseTemeList()[t].amongThemArea();
                    }
                    else {
                        amongThemArea = amongThemArea + ';' + this.houseTemeList()[t].amongThem() + ',' + this.houseTemeList()[t].amongThemArea();
                    }
                }
            }
            else {
                if (this.houseTemeList()[t].amongThem() == '请选择' && !this.houseTemeList()[t].amongThemArea()) {
                    // return ;
                }
                else {
                    if (this.houseTemeList()[t].amongThem() == '请选择' || !this.houseTemeList()[t].amongThemArea()) {
                        return window.popBox.show('第' + Number(t + 1) + '条其他住宅数据不完整!');
                    }
                }
            }
        }
        // if (this.amongThem() == '请选择') {
        //     if (this.amongThemArea()) {
        //         return window.popBox.show('请选择住宅类型');
        //     }
        // } else {
        //     if (this.amongThemArea()) {
        //         if (this.amongThemArea().lenth > 15) {
        //             return window.popBox.show('某类型住宅面积字段长度不能大于15个字符');
        //         } else {
        //             amongThemArea = this.amongThem() + ',' + this.amongThemArea();
        //         }
        //     }
        // }
        // 商业面积
        var commercialArea;
        if (!this.commercialAreaTBD()) {
            if (this.commercialArea()) {
                if (this.commercialArea().length > 15) {
                    return window.popBox.show('商业面积字段长度不能大于15个字符');
                }
                else {
                    commercialArea = this.commercialArea();
                }
            }
            else {
                return window.popBox.show('请填写商业面积');
            }
        }
        else {
            commercialArea = '待定';
        }
        var amongBusinesses = '';
        if (this.amongBusinesses() == '请选择') {
            if (this.amongBusinessesArea()) {
                return window.popBox.show('请选择商业类型');
            }
        }
        else {
            if (this.amongBusinessesArea()) {
                if (this.amongBusinessesArea().lenth > 15) {
                    return window.popBox.show('某类型商业面积字段长度不能大于15个字符');
                }
                else {
                    amongBusinesses = this.amongBusinesses() + ',' + this.amongBusinessesArea();
                }
            }
        }
        // 写字楼面积
        var officAerea;
        if (!this.officAereaTBD()) {
            if (this.officAerea()) {
                if (this.officAerea().length > 15) {
                    return window.popBox.show('写字楼面积字段长度不能大于15个字符');
                }
                else {
                    officAerea = this.officAerea();
                }
            }
            else {
                return window.popBox.show('请填写写字楼面积');
            }
        }
        else {
            officAerea = '待定';
        }
        // 地下室面积
        var basementArea;
        if (!this.basementAreaTBD()) {
            if (this.basementArea()) {
                if (this.basementArea().length > 15) {
                    return window.popBox.show('地下室面积字段长度不能大于15个字符');
                }
                else {
                    basementArea = this.basementArea();
                }
            }
            else {
                return window.popBox.show('请填写地下室面积');
            }
        }
        else {
            basementArea = '待定';
        }
        // 层数
        var basementFloors;
        if (!this.basementFloorsTBD()) {
            if (this.basementFloors()) {
                if (this.basementFloors().length > 15) {
                    return window.popBox.show('地下室层数字段长度不能大于15个字符');
                }
                else {
                    basementFloors = this.basementFloors();
                }
            }
            else {
                return window.popBox.show('请填写地下室层数');
            }
        }
        else {
            basementFloors = '待定';
        }
        // 会所面积
        var clubArea;
        if (!this.clubAreaTBD()) {
            if (this.clubArea()) {
                if (this.clubArea().length > 15) {
                    return window.popBox.show('会所面积字段长度不能大于15个字符');
                }
                else {
                    clubArea = this.clubArea();
                }
            }
            else {
                return window.popBox.show('请填写会所面积');
            }
        }
        else {
            clubArea = '无';
        }
        // 公建面积
        var publicConstructionArea;
        if (!this.publicConstructionAreaTBD()) {
            if (this.publicConstructionAreaType() == '请选择') {
                return window.popBox.show('请选择公建类型');
            }
            if (this.publicConstructionArea()) {
                if (this.publicConstructionArea().length > 15) {
                    return window.popBox.show('公建面积字段长度不能大于15个字符');
                }
                else {
                    publicConstructionArea = this.publicConstructionAreaType() + ',' + this.publicConstructionArea();
                }
            }
            else {
                return window.popBox.show('请填写公建面积');
            }
        }
        else {
            publicConstructionArea = '无';
        }
        if (this.afforestationRate()) {
            if (this.afforestationRate().length > 15) {
                return window.popBox.show('绿化率字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写绿化率');
        }
        if (this.afforestedArea()) {
            if (this.afforestedArea().length > 15) {
                return window.popBox.show('绿化面积字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写绿化面积');
        }
        // 电梯品牌
        // if (!this.liftBrand()) {
        //     return window.popBox.show('请填写电梯品牌');
        // }
        var liftBrand;
        if (!this.liftBrandTBD()) {
            if (this.liftBrand()) {
                if (this.liftBrand().length > 15) {
                    return window.popBox.show('电梯品牌字段长度不能大于30个字符');
                }
                else {
                    liftBrand = this.liftBrand();
                }
            }
            else {
                return window.popBox.show('请填写电梯品牌');
            }
        }
        else {
            liftBrand = '待定';
        }
        // 电梯数量
        if (this.verticalLadder()) {
            if (this.verticalLadder().length > 15) {
                return window.popBox.show('垂直梯字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写垂直梯数量');
        }
        var escalator = '';
        if (this.escalatorTBD()) {
            escalator = '无';
        }
        else {
            if (this.escalator()) {
                if (this.escalator().length > 15) {
                    return window.popBox.show('扶梯字段长度不能大于15个字符');
                }
                else {
                    escalator = this.escalator();
                }
            }
            else {
                return window.popBox.show('请填写扶梯数量或选择无扶梯');
            }
        }
        // 电梯合计
        if (this.totallift()) {
            if (this.totallift().length > 20) {
                return window.popBox.show('电梯合计字段长度不能大于20个字符');
            }
            else {
                if (this.verticalLadder() && this.escalator() && !this.escalatorTBD()) {
                    if ((Number(this.verticalLadder()) + Number(this.escalator())) != Number(this.totallift())) {
                        return window.popBox.show('电梯合计数量与垂直梯加扶梯数不符');
                    }
                }
                if (this.verticalLadder() && this.escalatorTBD()) {
                    if (Number(this.verticalLadder()) != Number(this.totallift())) {
                        return window.popBox.show('电梯合计数量与垂直梯加扶梯数不符');
                    }
                }
            }
        }
        else {
            return window.popBox.show('请填写电梯合计数量');
        }
        // 车场指标
        if (this.parkingGroundCount()) {
            if (this.parkingGroundCount().length > 15) {
                return window.popBox.show('地面车位数量字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写地面车位数量');
        }
        if (this.parkingGroundArea()) {
            if (this.parkingGroundArea().length > 15) {
                return window.popBox.show('地面车位面积字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写地面车位面积');
        }
        if (this.parkingUndergroundCount()) {
            if (this.parkingUndergroundCount().length > 15) {
                return window.popBox.show('地下车位数量字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写地下车位数量');
        }
        if (this.parkingUndergroundArea()) {
            if (this.parkingUndergroundArea().length > 15) {
                return window.popBox.show('地下车位面积字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写地下车位面积');
        }
        // 出入口
        if (this.garageEntrance()) {
            if (this.garageEntrance().length > 15) {
                return window.popBox.show('车场入口数量字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写车场入口数量');
        }
        if (this.garageExit()) {
            if (this.garageExit().length > 15) {
                return window.popBox.show('车场出口字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写车场出口数量');
        }
        if (this.communityEntrance()) {
            if (this.communityEntrance().length > 15) {
                return window.popBox.show('小区入口数量字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写小区入口数量');
        }
        if (this.communityExit()) {
            if (this.communityExit().length > 15) {
                return window.popBox.show('小区出口数量字段长度不能大于15个字符');
            }
        }
        else {
            return window.popBox.show('请填写小区出口数量');
        }
        // 四个单位
        // if (!this.architecturalUnit()) {
        //     return window.popBox.show('请填写建筑规划设计单位');
        // }
        // if (!this.landscapeUnit()) {
        //     return window.popBox.show('请填写园林景观设计单位');
        // }
        // if (!this.salesUnit()) {
        //     return window.popBox.show('请填写销售策划单位');
        // }
        // if (!this.constructionUnit()) {
        //     return window.popBox.show('请填写工程施工单位');
        // }
        // 项目规划设计要点及设计说明书
        if (this.projectKey()) {
            if (this.projectKey().length > 400) {
                return window.popBox.show('项目规划设计要点字段长度不能大于400个字符');
            }
        }
        if (this.designExplanation()) {
            if (this.designExplanation().length > 400) {
                return window.popBox.show('设计说明字段长度不能大于400个字符');
            }
        }
        // 物业类型
        var regionalType;
        for (var re = 0; re < this.regionalType().length; re++) {
            if (re < 1) {
                regionalType = this.regionalType()[0];
            }
            else {
                regionalType = regionalType + ',' + this.regionalType()[re];
            }
        }
        var planningMap = JSON.stringify(this.editorone.txt.html());
        var effective = JSON.stringify(this.editortwo.txt.html());
        ajax.post('/api/project/supplement', {
            projectId: this.dataId(),
            closingDate: this.closingDate(),
            stage: this.stage(),
            informationSources: this.informationSources(),
            signingBody: signingBody,
            projectType: projectType,
            developer: this.developer(),
            ownerSession: this.ownerSession(),
            ownerNumber: this.ownerNumber(),
            contacts: this.contacts(),
            post: this.post(),
            contactNumber: this.contactNumber(),
            supervisor: this.supervisor(),
            supervisorPosition: this.supervisorPosition(),
            supervisorNumber: this.supervisorNumber(),
            propertyName: this.propertyName(),
            location: this.localid().name + ',' + this.localsomeid().name + ',' + this.location(),
            // sizhi: this.sizhi(),//四至
            east: this.east(),
            west: this.west(),
            south: this.south(),
            north: this.north(),
            regionalType: regionalType,
            areaName: this.areaName(),
            commencementDate: commencementDate,
            completionDate: completionDate,
            openDate: openDate,
            accessionDate: accessionDate,
            areaCovered: this.areaCovered(),
            totalBuildings: totalBuildings,
            lobbyNumber: this.lobbyNumber(),
            totalHouseholds: this.totalHouseholds(),
            totalArea: totalArea,
            byStages: byStages,
            numberPeriods: this.numberPeriods(),
            numberPeriodsBuilding: this.numberPeriodsBuilding(),
            numberPeriodsResidential: this.numberPeriodsResidential(),
            amongThem: amongThemArea,
            commercialArea: commercialArea,
            amongBusinesses: amongBusinesses,
            officAerea: officAerea,
            basementArea: basementArea,
            basementFloors: basementFloors,
            clubArea: clubArea,
            publicConstructionArea: publicConstructionArea,
            afforestationRate: this.afforestationRate(),
            afforestedArea: this.afforestedArea(),
            liftBrand: liftBrand,
            verticalLadder: this.verticalLadder(),
            escalator: escalator,
            totallift: this.totallift(),
            parkingGroundCount: this.parkingGroundCount(),
            parkingGroundArea: this.parkingGroundArea(),
            parkingUndergroundCount: this.parkingUndergroundCount(),
            parkingUndergroundArea: this.parkingUndergroundArea(),
            garageEntrance: this.garageEntrance(),
            garageExit: this.garageExit(),
            communityEntrance: this.communityEntrance(),
            communityExit: this.communityExit(),
            architecturalUnit: this.architecturalUnit(),
            landscapeUnit: this.landscapeUnit(),
            salesUnit: this.salesUnit(),
            constructionUnit: this.constructionUnit(),
            projectKey: this.projectKey(),
            designExplanation: this.designExplanation(),
            planningMap: planningMap,
            effective: effective,
        }).then(function (d) {
            if (d.status == '0') {
                window.popBox.show(d.message).then(function (d) {
                    _this.goBack();
                });
            }
        }).catch(function (err) {
            if (err.status == '2') {
                window.popBox.show(err.message);
            }
        });
    };
    // 取消
    projectInfoModel.prototype.quick = function () {
        this.clear();
        history.go(-1);
    };
    projectInfoModel.prototype.clear = function () {
        this.closingDate(''); //截止到填表时间
        this.stage(''); //该物业开发工作进行至 阶段
        this.informationSources(''); //信息来源
        this.signingBodyList([{ text: '请选择', val: 0 }, { text: '开元国际', val: 1 }, { text: '万象美', val: 2 }]); //签约主体数组
        this.signingBody('请选择'); //签约主体
        this.otherSigningBody(false); //签约主体其他单选
        this.otherSigningBodyVal(''); //签约主体其他单选input值
        this.projectType('请选择'); //项目类别
        this.projectTypeList([{ name: '请选择' }, { name: '开发商项目' }, { name: '业委会项目' }]); //项目类别数组
        this.developer(''); //发展商
        this.ownerSession(''); //业主委员会第几届
        this.ownerNumber(''); //共几人
        this.contacts(''); //联系人：
        this.post(''); //职务：
        this.contactNumber(''); //联系电话：
        this.supervisor(''); //主管人：
        this.supervisorPosition(''); //主管职务：
        this.supervisorNumber(''); //主管联系电话：
        this.propertyName(''); //物业名称：
        this.location(''); //坐落位置：详细
        // 四至
        this.east(''); //
        this.west(''); //
        this.south(''); //
        this.north(''); //
        this.regionalType([]); //物业类型
        this.regionalTypeList([{ name: '多层' }, { name: '小高层' }, { name: '高层' }, { name: '超高层' }, { name: '商住楼' }, { name: '混合' }, { name: '住宅区' }, { name: '组团' }, { name: '写字楼' }, { name: '工业区' }]); //物业类型
        this.areaName(''); //周边自然环境描述：
        this.commencementDate(''); //开工日期：
        this.commencementDateTBD(false); //开工日期：待定
        this.completionDate(''); //竣工日期：
        this.completionDateTBD(false); //竣工日期：待定
        this.openDate(''); //开盘日期：
        this.openDateTBD(false); //开盘日期：待定
        this.accessionDate(''); //入伙日期：
        this.accessionDateTBD(false); //入伙日期：待定
        this.areaCovered(''); //占地面积：
        this.totalBuildings(''); //建筑总栋数：
        this.totalBuildingsTBD(false); //建筑总栋数：待定
        this.lobbyNumber(''); //大堂数：
        this.totalHouseholds(''); //总户数：
        this.totalArea(''); //总建筑面积：
        this.totalAreaTBD(false); //总建筑面积：待定
        this.byStages(''); //开发期数：
        this.byStagesTBD(false); //开发期数：待定
        this.numberPeriods(''); //第 期 
        this.numberPeriodsBuilding(''); //建筑面积：
        this.numberPeriodsResidential(''); //住宅面积
        this.houseTemeList([{
                amongThem: ko.observable('请选择'), amongThemArea: ko.observable(''),
                amongThemList: ko.observableArray([{ name: '请选择' }, { name: '多层' }, { name: '高层' }, { name: '准高层' }, { name: '小高层' }, { name: '超高层' }])
            }]); //住宅其中数组
        this.commercialArea(''); //商业面积
        this.commercialAreaTBD(false); //商业面积待定
        this.amongBusinesses('请选择'); //商业其中
        this.amongBusinessesList([{ name: '请选择' }, { name: '临街' }, { name: '裙楼' }]); //商业类型
        this.amongBusinessesArea(''); //商业其中面积
        this.officAerea(''); //写字楼面积：
        this.officAereaTBD(false); //写字楼面积：待定
        this.basementArea(''); //地下室面积：
        this.basementAreaTBD(false); //地下室面积：待定
        this.basementFloors(''); //地下室层数
        this.basementFloorsTBD(false); //地下室层数待定
        this.clubArea(''); //会所面积：
        this.clubAreaTBD(false); //会所面积：无
        this.publicConstructionArea(''); //公建面积：大小
        this.publicConstructionAreaList([{ name: '请选择' }, { name: '幼儿园' }, { name: '小学' }, { name: '其他' }]); //公建类型
        this.publicConstructionAreaTBD(false); //公建面积：无
        this.publicConstructionAreaType('请选择'); //公建面积：类型
        this.afforestationRate(''); //绿化率：
        this.afforestedArea(''); //绿化面积：
        this.liftBrand(''); //电梯品牌：
        this.liftBrandTBD(false); //电梯品牌  待定
        this.verticalLadder(''); //电梯数量：垂直梯
        this.escalator(''); //电梯数量：扶梯
        this.escalatorTBD(false); //电梯数量：扶梯 无
        this.totallift(''); //电梯数量：合计
        this.parkingGroundCount(''); //车场指标：地面车位数量
        this.parkingGroundArea(''); //地面车位 面积 
        this.parkingUndergroundCount(''); //地下车位数量
        this.parkingUndergroundArea(''); //地下车位面积
        this.garageEntrance(''); //出入口：车场入口
        this.garageExit(''); //出入口：车场出口
        this.communityEntrance(''); //出入口：小区入口
        this.communityExit(''); //出入口：小区出口
        this.architecturalUnit(''); //建筑规划设计单位：
        this.landscapeUnit(''); //园林景观设计单位：
        this.salesUnit(''); //销售策划单位：
        this.constructionUnit(''); //工程施工单位：
        this.projectKey(''); //项目规划设计要点：
        this.designExplanation(''); //设计说明：
        this.planningMap(''); //项目规划设计要点及设计说明书
        this.effective(''); //有效洽谈记录
        // 富文本编辑器清空
        this.editorone.txt.clear();
        this.editortwo.txt.clear();
        this.getPrivine();
    };
    // 重置
    projectInfoModel.prototype.resetData = function () {
        if (this.dataId() == '0000') {
            this.clear();
        }
        else {
            this.getMarketData();
        }
    };
    // 获取省份
    projectInfoModel.prototype.getPrivine = function () {
        var _this = this;
        ajax.get('/api/ice/local', { pid: 1 }).then(function (d) {
            _this.local(d.data);
        });
    };
    //省份二级联动
    projectInfoModel.prototype.changelocal = function () {
        var _this = this;
        var id = this.localid().id;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
        });
    };
    projectInfoModel.prototype.getCity = function (id, city) {
        var _this = this;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
            for (var n = 0; n < _this.localnext().length; n++) {
                if (_this.localnext()[n].name == city) {
                    _this.localsomeid(_this.localnext()[n]);
                }
            }
        });
    };
    // 获取数据
    projectInfoModel.prototype.getMarketData = function () {
        var _this = this;
        ajax.get('/api/project/supplement/' + this.dataId()).then(function (d) {
            if (d.data != null) {
                _this.closingDate(d.data.closingDate); //截止到填表时间
                _this.stage(d.data.stage); //该物业开发工作进行至 阶段
                _this.informationSources(d.data.informationSources); //信息来源
                //签约主体
                if (d.data.signingBody != '开元国际' && d.data.signingBody != '万象美') {
                    _this.otherSigningBodyVal(d.data.signingBody);
                    _this.otherSigningBody(true);
                }
                else {
                    // let str = { name: d.data.signingBody };
                    _this.signingBody(d.data.signingBody);
                }
                if (d.data.projectType) {
                    _this.projectType(d.data.projectType); //项目类别
                }
                _this.developer(d.data.developer); //发展商
                _this.ownerSession(d.data.ownerSession); //业主委员会第几届
                _this.ownerNumber(d.data.ownerNumber); //共几人
                _this.contacts(d.data.contacts); //联系人：
                _this.post(d.data.post); //职务：
                _this.contactNumber(d.data.contactNumber); //联系电话：
                _this.supervisor(d.data.supervisor); //主管人：
                _this.supervisorPosition(d.data.supervisorPosition); //主管职务：
                _this.supervisorNumber(d.data.supervisorNumber); //主管联系电话：
                _this.propertyName(d.data.propertyName); //物业名称：
                // 坐落位置
                for (var m = 0; m < _this.local().length; m++) {
                    if (_this.local()[m].name == d.data.location.substring(0, d.data.location.indexOf(','))) {
                        _this.localid(_this.local()[m]);
                    }
                }
                _this.getCity(_this.localid().id, d.data.location.substring(d.data.location.indexOf(',') + 1, d.data.location.lastIndexOf(',')));
                _this.location(d.data.location.substring(d.data.location.lastIndexOf(',') + 1, d.data.location.length));
                // this.localid().name + ',' + this.localsomeid().name + ',' + this.location();//坐落位置：详细
                //四至
                _this.east(d.data.east); //
                _this.west(d.data.west); //
                _this.south(d.data.south); //
                _this.north(d.data.north); //
                //物业类型
                _this.regionalType(d.data.regionalType.split(","));
                _this.areaName(d.data.areaName); //周边自然环境描述：
                //开工日期
                if (d.data.commencementDate == '待定') {
                    _this.commencementDateTBD(true);
                }
                else {
                    _this.commencementDate(d.data.commencementDate);
                }
                //竣工日期：
                if (d.data.completionDate == '待定') {
                    _this.completionDateTBD(true);
                }
                else {
                    _this.completionDate(d.data.completionDate);
                }
                //开盘日期
                if (d.data.openDate == '待定') {
                    _this.openDateTBD(true);
                }
                else {
                    _this.openDate(d.data.openDate);
                }
                //入伙日期
                if (d.data.accessionDate == '待定') {
                    _this.accessionDateTBD(true);
                }
                else {
                    _this.accessionDate(d.data.accessionDate);
                }
                _this.areaCovered(d.data.areaCovered); //占地面积：
                //建筑总栋数：
                if (d.data.totalBuildings == '待定') {
                    _this.totalBuildingsTBD(true);
                }
                else {
                    _this.totalBuildings(d.data.totalBuildings);
                }
                _this.lobbyNumber(d.data.lobbyNumber); //大堂数：
                _this.totalHouseholds(d.data.totalHouseholds); //总户数：
                //总建筑面积：
                if (d.data.totalArea == '待定') {
                    _this.totalAreaTBD(true);
                }
                else {
                    _this.totalArea(d.data.totalArea);
                }
                //开发期数：
                if (d.data.byStages == '待定') {
                    _this.byStagesTBD(true);
                }
                else {
                    _this.byStages(d.data.byStages);
                }
                _this.numberPeriods(d.data.numberPeriods); //第 期 
                _this.numberPeriodsBuilding(d.data.numberPeriodsBuilding); //建筑面积：
                _this.numberPeriodsResidential(d.data.numberPeriodsResidential); //住宅面积：
                //住宅其中 类型
                if (d.data.amongThem != '') {
                    if (d.data.amongThem.indexOf(';') == -1) {
                        var arr = d.data.amongThem.split(",");
                        _this.houseTemeList()[0].amongThem(arr[0]);
                        _this.houseTemeList()[0].amongThemArea(arr[1]);
                    }
                    else {
                        var arr = d.data.amongThem.split(";");
                        _this.houseTemeList([]);
                        for (var i = 0; i < arr.length; i++) {
                            _this.houseTemeList.push({
                                amongThem: ko.observable('请选择'), amongThemArea: ko.observable(''),
                                amongThemList: ko.observableArray([{ name: '请选择' }, { name: '多层' }, { name: '高层' }, { name: '准高层' }, { name: '小高层' }, { name: '超高层' }])
                            });
                        }
                        for (var ar = 0; ar < arr.length; ar++) {
                            var hr = arr[ar].split(",");
                            _this.houseTemeList()[ar].amongThem(hr[0]);
                            _this.houseTemeList()[ar].amongThemArea(hr[1]);
                        }
                    }
                }
                //商业面积
                if (d.data.commercialArea == '待定') {
                    _this.commercialAreaTBD(true);
                }
                else {
                    _this.commercialArea(d.data.commercialArea);
                }
                //商业其中
                if (d.data.amongBusinesses != '') {
                    var arr = d.data.amongBusinesses.split(",");
                    // let str = { name: arr[0] };
                    _this.amongBusinesses(arr[0]);
                    _this.amongBusinessesArea(arr[1]);
                    // this.amongBusinesses(this.amongBusinesses());
                }
                //写字楼面积：
                if (d.data.officeArea == '待定') {
                    _this.officAereaTBD(true);
                }
                else {
                    _this.officAerea(d.data.officeArea);
                }
                //地下室面积：
                if (d.data.basementArea == '待定') {
                    _this.basementAreaTBD(true);
                }
                else {
                    _this.basementArea(d.data.basementArea);
                }
                //地下室层数
                if (d.data.basementFloors == '待定') {
                    _this.basementFloorsTBD(true);
                }
                else {
                    _this.basementFloors(d.data.basementFloors);
                }
                //会所面积：
                if (d.data.clubArea == '无') {
                    _this.clubAreaTBD(true);
                }
                else {
                    _this.clubArea(d.data.clubArea);
                }
                //公建面积 类型+面积
                if (d.data.publicConstructionArea == '无') {
                    _this.publicConstructionAreaTBD(true);
                }
                else {
                    var arr = d.data.publicConstructionArea.split(",");
                    _this.publicConstructionArea(arr[1]);
                    _this.publicConstructionAreaType(arr[0]);
                    // this.publicConstructionAreaType(this.publicConstructionAreaType());
                }
                _this.afforestationRate(d.data.afforestationRate); //绿化率：
                _this.afforestedArea(d.data.afforestedArea); //绿化面积：
                // this.liftBrand(d.data.liftBrand);//电梯品牌：
                if (d.data.liftBrand == '待定') {
                    _this.liftBrandTBD(true);
                }
                else {
                    _this.liftBrand(d.data.liftBrand);
                }
                _this.verticalLadder(d.data.verticalLadder); //电梯数量：垂直梯
                //电梯数量：扶梯
                if (d.data.escalator == '无') {
                    _this.escalatorTBD(true);
                }
                else {
                    _this.escalator(d.data.escalator);
                }
                _this.totallift(d.data.totallift); //电梯数量：合计
                _this.parkingGroundCount(d.data.parkingGroundCount); //车场指标：地面车位数量
                _this.parkingGroundArea(d.data.parkingGroundArea); //地面车位 面积 
                _this.parkingUndergroundCount(d.data.parkingUndergroundCount); //地下车位数量
                _this.parkingUndergroundArea(d.data.parkingUndergroundArea); //地下车位面积
                _this.garageEntrance(d.data.garageEntrance); //出入口：车场入口
                _this.garageExit(d.data.garageExit); //出入口：车场出口
                _this.communityEntrance(d.data.communityEntrance); //出入口：小区入口
                _this.communityExit(d.data.communityExit); //出入口：小区出口
                _this.architecturalUnit(d.data.architecturalUnit); //建筑规划设计单位：
                _this.landscapeUnit(d.data.landscapeUnit); //园林景观设计单位：
                _this.salesUnit(d.data.salesUnit); //销售策划单位：
                _this.constructionUnit(d.data.constructionUnit); //工程施工单位：
                _this.projectKey(d.data.projectKey); //项目规划设计要点：
                _this.designExplanation(d.data.designExplanation); //设计说明：
                // 富文本数据
                //项目规划设计要点及设计说明书
                _this.planningMap(d.data.planningMap);
                //有效洽谈记录
                _this.effective(d.data.effective);
                _this.editorone.cmd.do('insertHtml', JSON.parse(d.data.planningMap));
                // this.editorone.txt.html('<p>' + d.data.planningMap + '</p>');
                _this.editortwo.cmd.do('insertHtml', JSON.parse(d.data.effective));
            }
            else {
                _this.clear();
            }
        });
    };
    // 回到顶部
    projectInfoModel.prototype.scrollTop = function () {
        this.container.querySelector('.projectInfo_body').scrollTop = 0;
    };
    return projectInfoModel;
}(KnockoutModel));
var projectInfo = /** @class */ (function (_super) {
    __extends(projectInfo, _super);
    function projectInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    projectInfo.prototype.init = function () {
        this.vm = new projectInfoModel(this.container.querySelector('.projectInfo'));
        this.vm.bind();
    };
    projectInfo.prototype.update = function (arg) {
        var _this = this;
        this.vm.scrollTop();
        this.vm.getPrivine();
        if (arg.routeData.query.isCheck) {
            if (arg.routeData.query.isCheck == 'yes') {
                this.vm.isCheck(true);
            }
            else {
                this.vm.isCheck(false);
            }
            // this.vm.isCheck(arg.routeData.query.isCheck);
        }
        if (arg.routeData.query.pId) {
            this.vm.dataId(arg.routeData.query.pId);
            setTimeout(function () {
                _this.vm.getMarketData();
            }, 500);
        }
        return Promise.resolve();
    };
    projectInfo.prototype.onInitComplete = function () {
        this.vm.getEditor();
    };
    return projectInfo;
}(Page));
export default projectInfo;
